export const MENU_SHADOW =
  '-4px 0 8px rgba(0, 0, 0, 0.15), 4px 0 8px rgba(0, 0, 0, 0.15), 0 -4px 8px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.15)';

const listItemIcon = ({ palette }) => ({
  minWidth: 'unset',
  color: palette.text.primary,
  '> svg': {
    width: 16,
    height: 16,
  },
});

export const menuStyles = {
  listItemIcon,
  panel: ({ breakpoints, palette }) => ({
    minWidth: 200,
    backgroundColor: palette.common.white,
    border: `1px solid ${palette.colors.darkPale}`,
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: MENU_SHADOW,
    [breakpoints.up('md')]: {
      minWidth: 250,
    },
  }),
  item: ({ breakpoints, palette }) => ({
    borderColor: palette.colors.darkPale,
    flexDirection: 'column',
    alignItems: 'stretch',

    '.MuiListItemButton-root': {
      width: '100%',
      height: 34,
      padding: 1,
      gap: 1.5,
      color: palette.colors.darkBlue,

      '&:hover, &.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: palette.colors.lightPale,
      },

      '&:hover .MuiTypography-body1, &.Mui-selected .MuiTypography-body1': {
        fontWeight: 600,
      },

      '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },

      '&.Mui-selected.Mui-focusVisible': {
        backgroundColor: palette.colors.lightPale,
      },

      [breakpoints.up('md')]: {
        height: 48,
        padding: 2,
      },
    },

    '.MuiListItemIcon-root': listItemIcon({ palette }),
  }),
  selectOption: ({ palette }) => ({
    borderColor: palette.colors.darkPale,
    color: palette.text.primary,
    backgroundColor: palette.common.white,

    '&.Mui-focusVisible': {
      backgroundColor: palette.common.white,
    },

    '&:hover, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
      backgroundColor: palette.colors.lightPale,
      fontWeight: 600,
    },

    '&:hover .MuiTypography-root, &.Mui-selected .MuiTypography-root': {
      fontWeight: 600,
    },
  }),
  autocompleteOption: ({ palette }) => ({
    '&.Mui-focused, &[aria-selected="true"], &[aria-selected="true"].Mui-focused': {
      backgroundColor: palette.colors.lightPale,
      fontWeight: 600,
    },
  }),
};
